import { useEffect, useState } from 'react';
import Breadcrumbs from '@Components/Breadcrumbs';
import Loader from '@Components/Loader';
import Dashboard from '@Components/Dashboard';
import { Tabs, TabsList, TabsTrigger } from '@Components/Tabs/index';
import { useLocation, useParams } from 'react-router-dom';
import { useWorkspace } from '@Hooks/useWorkspaces';
import Heading from '@Components/Heading';
import { toastError } from '@art-of-hospitality-solutions-llc/ui-kit/components/toast';
import { useSearchParams } from 'react-router-dom';

const WorkspaceViewer = () => {
  const [selectedTab, setSelectedTab] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const { id } = useParams();
  const location = useLocation();
  const from = location.pathname.includes('cards') ? 'Cards' : 'Manager';

  const {
    data: workspace,
    isError,
    error,
  } = useWorkspace({
    id: id,
    searchParams: {},
  });

  useEffect(() => {
    if (isError && error) {
      toastError(
        error instanceof Error ? error.message : 'Failed to load Workspaces',
      );
    }
  }, [isError, error]);

  useEffect(() => {
    if (workspace?.dashboards?.length && !selectedTab) {
      setSelectedTab(workspace.dashboards[0].dashboard?.id);
    }
  }, [workspace]);

  useEffect(() => {
    const dashboardId = searchParams.get('dashboard');
    if (dashboardId) {
      setSelectedTab(dashboardId);
    }
  }, []);

  return (
    <div className="flex flex-col gap-4">
      <Breadcrumbs
        navList={[
          { name: 'Workspaces', href: '/workspaces' },
          { name: from, href: `/workspaces/${from.toLowerCase()}` },
          {
            name: workspace?.name ? workspace.name : '-',
            href: `/workspaces/${workspace?.id}`,
          },
        ]}
      />

      <div>
        <Heading>Workspace - {workspace?.name}</Heading>
      </div>

      {selectedTab && (
        <Tabs
          defaultValue={selectedTab}
          onValueChange={(value) => {
            setSelectedTab(value);
            setSearchParams({ dashboard: value });
          }}
        >
          <TabsList>
            {workspace &&
              workspace.dashboards?.map((dash) => {
                return (
                  <TabsTrigger
                    key={`dashboardTab-${dash.id}`}
                    value={dash.dashboard?.id}
                    className="rounded border-b-4 data-[state=active]:border-yellow-500 data-[state=inactive]:border-transparent"
                  >
                    {dash.dashboard?.name}
                  </TabsTrigger>
                );
              })}
          </TabsList>
        </Tabs>
      )}

      <div className="flex w-full items-center justify-between">
        <div className="flex w-1/3"></div>

        <div className="flex w-1/3">{isLoading && <Loader />}</div>
      </div>

      {workspace &&
        workspace.dashboards?.map((dash) => {
          return (
            <div
              key={`dashboard-${dash.id}`}
              className={
                selectedTab === dash.dashboard?.id ? 'block' : 'hidden'
              }
            >
              <Dashboard id={dash.dashboardId} setIsLoading={setIsLoading} />
            </div>
          );
        })}
    </div>
  );
};

export default WorkspaceViewer;
